export const DEFAULT_SERVICE_USAGE_PLACEHOLDER_HEIGHT = 194;

export const SERVICE_USAGE_CARD_MIN_HEIGHT = 380;

export const SERVICE_USAGE_CARD_SX = {
  flexGrow: 1,
  display: 'flex',
  minHeight: SERVICE_USAGE_CARD_MIN_HEIGHT,
} as const;

export const SERVICE_USAGE_CARD_SIZE = {
  lg: 3,
  md: 6,
  xs: 12,
} as const;
